import './modules/inline-iframes';
import './modules/sliders';
import * as Contact from './modules/contact-form';
import * as Parallax from './modules/parallax';

// Contact Form
if (document.querySelector('.js-contact-form')) {
    Contact.init();
}

// Parallax Images
if (document.querySelectorAll('.js-parallax-image')) {
    Parallax.init();
}